export default __webpack_public_path__ + "static/media/blank.d1f25d59.jpg";